export function reorder<T>(list: T[], sourceIndex: number, destinationIndex: number): T[] {
	const result = Array.from(list);
	const [removed] = result.splice(sourceIndex, 1);
	result.splice(destinationIndex, 0, removed);
	return result;
}

export function immutableInsert<T>(
	itemToCopy: T,
	destination: T[],
	destinationIndex: number,
	copyFactory?: (itemToCopy: T) => T,
): T[] {
	const destClone = Array.from(destination);

	destClone.splice(destinationIndex, 0, copyFactory?.(itemToCopy) ?? itemToCopy);
	return destClone;
}

export function move<T>(
	source: T[],
	destination: T[],
	sourceIndex: number,
	destinationIndex: number,
): { newSource: T[]; newDestination: T[] } {
	const sourceClone = Array.from(source);
	const destClone = Array.from(destination);
	const [removed] = sourceClone.splice(sourceIndex, 1);

	destClone.splice(destinationIndex, 0, removed);

	return { newSource: sourceClone, newDestination: destClone };
}

export const offsetArray = <T>(days: T[], offset: number): T[] => [...days.slice(offset), ...days.slice(0, offset)];

export const indexOfOrDefault = <T>(array: T[], value: T, defaultValue: T): number => {
	const index = array.indexOf(value);
	return index === -1 ? array.indexOf(defaultValue) : index;
};
